import { JSX } from 'react';
import { IconCtaBorderedCard } from '@ahc-digital/component-library';
import { CreateIconCTABorderedCardModel } from './C31IconCTABorderedCard.service';

import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';
import { C31IconCTABorderedCardProps } from './C31IconCTABorderedCard.types';

const Default = (props?: C31IconCTABorderedCardProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return (
    <IconCtaBorderedCard
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
      {...CreateIconCTABorderedCardModel(props)}
    />
  );
};

export default checkDatasourceForRendering<C31IconCTABorderedCardProps>(Default);
